/* eslint-disable max-len */
const ChestSVG = () => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 64 64"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        fillRule: "evenodd",
        clipRule: "evenodd",
        strokeLinejoin: "round",
        strokeMiterlimit: 2,
        // fill: "#6764d7",
        // stroke: "black",
      }}
    >
      <g transform="matrix(1,0,0,1,0,-64)">
        <g className="chest-svg" transform="matrix(1,0,0,1,0,-832)">
          <g className="svg-background" transform="matrix(1,0,0,1,-64,0)">
            <path
              d="M101,909L107,903L117,903L120,906L120,915L115,915L115,919L114,920L115,921L115,925L114,925.5L115,926L115,930L111,934L111,941L117,947L117,950L116,951L76,951L75,950L75,947L81,941L81,934L77,930L77,926L78,925.5L77,925L77,921L78,920L77,919L77,915L72,915L72,906L75,903L85,903L91,909L101,909Z"
              style={{ fillOpacity: 0.76 }}
            />
          </g>
          <g className="color_02" transform="matrix(1,0,0,1,-64,0)">
            <path
              d="M75,947L78,944L114,944L117,947L75,947ZM115,925C115,924.448 114.552,924 114,924L113,924C112.448,924 112,924.448 112,925L112,926C112,926.552 112.448,927 113,927L114,927C114.552,927 115,926.552 115,926L115,925ZM80,925C80,924.448 79.552,924 79,924L78,924C77.448,924 77,924.448 77,925L77,926C77,926.552 77.448,927 78,927L79,927C79.552,927 80,926.552 80,926L80,925ZM83,924L83,922C83,922 83,921 82,921L77,921L77,919L79,919L84,914L84,916C84,916 84,917 85,917L89,917C90,917 90,916 90,916L90,909L102,909L102,916C102,916 102,917 103,917L107,917C108,917 108,916 108,916L108,914L113,919L115,919L115,921L110,921C109,921 109,922 109,922L109,924L83,924Z"
              // style={{ fill: "#6764d7" }}
            />
          </g>
          <g className="color_01" transform="matrix(1,0,0,1,-64,0)">
            <path
              d="M117,950L75,950L75,954L117,954L117,950ZM80,942L80,936L77,933L77,930L83,930L83,928C83,928 83,927 84,927L108,927C109,927 109,928 109,928L109,930L115,930L115,933L112,936L112,942L80,942ZM98,938C98,937.448 97.552,937 97,937L95,937C94.448,937 94,937.448 94,938L94,939C94,939.552 94.448,940 95,940L97,940C97.552,940 98,939.552 98,939L98,938ZM110,938C110,937.448 109.552,937 109,937L107,937C106.448,937 106,937.448 106,938L106,939C106,939.552 106.448,940 107,940L109,940C109.552,940 110,939.552 110,939L110,938ZM104,938C104,937.448 103.552,937 103,937L101,937C100.448,937 100,937.448 100,938L100,939C100,939.552 100.448,940 101,940L103,940C103.552,940 104,939.552 104,939L104,938ZM92,938C92,937.448 91.552,937 91,937L89,937C88.448,937 88,937.448 88,938L88,939C88,939.552 88.448,940 89,940L91,940C91.552,940 92,939.552 92,939L92,938ZM86,938C86,937.448 85.552,937 85,937L83,937C82.448,937 82,937.448 82,938L82,939C82,939.552 82.448,940 83,940L85,940C85.552,940 86,939.552 86,939L86,938ZM107,902L117,902L121,906L121,916L114,916L107,909L107,902ZM85,902L75,902L71,906L71,916L78,916L85,909L85,902ZM117,910C118.104,910 119,910.896 119,912C119,913.104 118.104,914 117,914C115.896,914 115,913.104 115,912C115,910.896 115.896,910 117,910ZM75,910C73.896,910 73,910.896 73,912C73,913.104 73.896,914 75,914C76.104,914 77,913.104 77,912C77,910.896 76.104,910 75,910ZM117,905C118.104,905 119,905.896 119,907C119,908.104 118.104,909 117,909C115.896,909 115,908.104 115,907C115,905.896 115.896,905 117,905ZM75,905C73.896,905 73,905.896 73,907C73,908.104 73.896,909 75,909C76.104,909 77,908.104 77,907C77,905.896 76.104,905 75,905Z"
              // style={{ fill: "#6764d7" }}
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default ChestSVG;
